import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, SAMPLE_TO_SALE_SCREEN, COMMON, API_CONSTANTS } from '../../global/Constants';
import { ActivityStatusType } from '../../global/Enum';
import './sample-to-sale.css';
import Select from 'react-select';
import AddNewImages from '../common/AddNewImages';
import GpsCoordinates from '../common/GpsCoordinates';
import Utilities from '../../global/Utilities';
import DataProvider from '../../providers/DataProvider';

class AddRiceHarvest extends Component {

    constructor(props) {
        super(props)

        this.state = {
            activity: {},

            harvestingDate: '',
            threshingDate: '',
            yieldValue: "",
            moisture: "",
            population: "",

            varietyHarvestingDate: '',
            varietyThreshingDate: '',
            varietyYield: "",
            varietyMoisture: "",
            varietyPopulation: "",

            remarks: '',
            latitude: '',
            longitude: "",
            nextActivity: '',
            nextPickDate: '',
            images: [],

            checkVariety: [],
            selectedCheckVariety: null,

            nextActivityOptions: [
                { id: 0, name: COMMON.YES, checked: true },
                { id: 1, name: COMMON.NO, checked: false },
            ],
            deletedImages: [],
        }
    }

    componentDidMount() {
        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            if (this.props.location.state !== undefined) {
                let activity = this.props.location.state.activity;
                if (activity !== undefined && activity !== null) {
                    let data = activity?.stage;
                    //const check_variety = data?.params?.check_varity?.map(({ competitor_hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest }));

                    this.setState({
                        activity: activity,
                        data: data,
                        harvestingDate: data?.params?.harvest_date,
                        varietyHarvestingDate: data?.params?.check_variety_harvest_date,
                        //checkVariety: check_variety,
                        //selectedCheckVariety: check_variety?.[0],
                        nextActivity: data?.params?.is_next_harvest,
                        nextPickDate: data?.params?.next_harvest_date,
                    }, () => {
                        this.getCompetitorHybrids(activity.hybrid_id);

                        if (activity?.harvest != null) {
                            let harvest = activity?.harvest;
                            let harvestObj = harvest?.harvestObj;

                            this.setState({
                                harvestingDate: harvestObj.harvest_date,
                                threshingDate: harvestObj?.check_harvest_threshiting_date,
                                yieldValue: harvestObj.harvest_yield_kg_plot,
                                moisture: harvestObj.harvest_moisture,
                                population: harvestObj.harvest_population,

                                varietyHarvestingDate: harvestObj.check_variety_harvest_date,
                                varietyThreshingDate: harvestObj?.check_harvest_threshiting_date,
                                varietyYield: harvestObj.check_variety_harvest_yield_kg_plot,
                                varietyMoisture: harvestObj.check_variety_harvest_moisture,
                                varietyPopulation: harvestObj.check_variety_harvest_population,

                                remarks: harvest?.remark,
                                images: harvest?.images,
                                nextActivity: harvestObj?.is_next_harvest,
                                nextPickDate: harvestObj?.next_harvest_date,
                                deletedImages: harvest?.deletedImages
                            }, () => {
                                this.getCompetitorHybridById(harvest?.competitor_hybrid_id);
                            });
                        } else {
                            this.setData();
                        }
                    });
                }

            } else {
                this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE)
        }
    }

    setData = () => {
        const { activity } = this.state;
        if (activity !== null && activity.activity_status_id !== ActivityStatusType.TO_START) {
            const harvests = activity?.data?.history?.stage_five;
            Utilities.LogPrint("Edit ", harvests);
            if (harvests !== undefined && harvests !== null && harvests.length > 0) {
                const harvestObj = harvests[harvests.length - 1];
                Utilities.LogPrint("Edit ", harvestObj);

                this.setState({
                    harvestingDate: harvestObj.harvest_date,
                    threshingDate: harvestObj?.check_harvest_threshiting_date,
                    yieldValue: harvestObj.harvest_yield_kg_plot,
                    moisture: harvestObj.harvest_moisture,
                    population: harvestObj.harvest_population,

                    varietyHarvestingDate: harvestObj.check_variety_harvest_date,
                    varietyThreshingDate: harvestObj?.check_harvest_threshiting_date,
                    varietyYield: harvestObj.check_variety_harvest_yield_kg_plot,
                    varietyMoisture: harvestObj.check_variety_harvest_moisture,
                    varietyPopulation: harvestObj.check_variety_harvest_population,

                    remarks: harvestObj?.remark,
                    images: harvestObj?.images,
                    nextActivity: harvestObj?.is_next_harvest === 1 ? true : false,
                    nextPickDate: harvestObj?.next_harvest_date
                }, () => {
                    this.getCompetitorHybridById(harvestObj?.competitor_hybrid_id);
                });
            }
        }
    }

    getCompetitorHybrids = (hybridId) => {
        const competitorHybrids = DataProvider.getInstance().getCompetitorHybrid(hybridId);
        if (competitorHybrids) {
            const checkVarietyArray = competitorHybrids?.map(({ competitor_hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest }));
            Utilities.LogPrint("CheckVarietyArray:-", checkVarietyArray);
            this.setState({
                checkVariety: checkVarietyArray,
                selectedCheckVariety: checkVarietyArray?.[0],
            });
        }
    }

    getCompetitorHybridById = (competitorHybridId) => {
        const { checkVariety } = this.state;
        if (checkVariety) {
            const competitorHybrid = checkVariety.find(item => item.value === competitorHybridId);
            if (competitorHybrid) {
                this.setState({ selectedCheckVariety: competitorHybrid });
            }
        }
    }


    backButton = () => {
        this.props.history.goBack();
        //this.props.history.push(ALL_ROUTES.SAMPLE_TO_SALE_ROUTE);
        // this.props.history.push({
        //     pathname: ALL_ROUTES.SAMPLE_TO_SALE_ROUTE,
        //     state: { activity: this.state.activity }
        // });
    }

    getInitialState = () => {
        return {
            type: 'text'
        };
    }

    changeHandler = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleChanged = (e) => {
        this.setState({ nextActivity: this.checkNextPickActivity(e.target.value) });
    }


    checkNextPickActivity(value) {
        var isNextActivity = (value === 'true');
        return isNextActivity
    }

    handleAddImages = (images) => {
        Utilities.LogPrint("Images", images);
        this.setState({ images: images });
    }

    handleDeleteImages = (deletedImage) => {
        //Utilities.LogPrint("Images Deleted", deletedImage);
        var deletedImagesArray = this.state.deletedImages.slice();
        deletedImagesArray.push({ image_id: deletedImage.image_id });
        if (deletedImagesArray.length > 0) {
            Utilities.LogPrint("DeletedImages", deletedImagesArray);
            this.setState({ deletedImages: deletedImagesArray });
        }
    }

    handleVarietyHybrid = item => {
        this.setState({ selectedCheckVariety: item });
    };

    getCoordinates = (latLng) => {
        this.setState({
            latitude: latLng.latitude,
            longitude: latLng.longitude
        })
    }

    handleSaveClick = () => {
        const { harvestingDate, threshingDate, yieldValue, moisture, population,
            varietyHarvestingDate, varietyThreshingDate, varietyYield, varietyMoisture, varietyPopulation,
            remarks, images, nextActivity, nextPickDate, latitude, longitude, selectedCheckVariety, deletedImages } = this.state;

        let harvest = {
            harvestObj: {
                harvest_date: harvestingDate,
                harvest_threshiting_date: threshingDate,
                harvest_yield_kg_plot: yieldValue,
                harvest_moisture: moisture,
                harvest_population: population,
                harvest_population_acer: this.calculatePopulationPerHa(population),
                harvest_yield_kg_acer: this.calculateYield(moisture, yieldValue),

                competitor_hybrid_id: selectedCheckVariety?.value,
                check_variety_harvest_date: varietyHarvestingDate,
                check_harvest_threshiting_date: varietyThreshingDate,
                check_variety_harvest_yield_kg_plot: varietyYield,
                check_variety_harvest_moisture: varietyMoisture,
                check_variety_harvest_population: varietyPopulation,
                check_harvest_population_acer: this.calculatePopulationPerHa(varietyPopulation),
                check_harvest_yield_kg_acer: this.calculateYield(varietyMoisture, varietyYield),

                is_next_harvest: nextActivity,
                next_harvest_date: nextPickDate,
            },
            remark: remarks,
            images: images,
            deletedImages: deletedImages,
            latitude: latitude,
            longitude: longitude
        }
        this.props.handleSaveButton(harvest);

    }

    isFormValid() {
        const { harvestingDate, threshingDate, yieldValue, moisture, population,
            varietyHarvestingDate, varietyThreshingDate, varietyYield, varietyMoisture, varietyPopulation, images } = this.state;
        return !harvestingDate || !threshingDate || !yieldValue || !moisture || !population || !varietyHarvestingDate
            || !varietyThreshingDate || !varietyYield || !varietyMoisture || !varietyPopulation || images === 0;
    }

    calculatePopulationPerHa(population) {
        if (population > 0) {
            let value = (population * 25) / 10000;
            return value;
        } else {
            return 0;
        }
    }

    calculateYield(moisture, yieldValue) {
        if (moisture > 0 && yieldValue > 0) {
            let value = ((100 - moisture) / (100 - 12)) * yieldValue * (10000 / 25);
            return parseFloat(value).toFixed(2);
        } else {
            return 0;
        }
    }

    render() {
        const { harvestingDate, threshingDate, yieldValue, moisture, population,
            varietyHarvestingDate, varietyThreshingDate, varietyYield, varietyMoisture, varietyPopulation,
            remarks, nextPickDate, nextActivity, nextActivityOptions, images,
            checkVariety, selectedCheckVariety } = this.state;

        const NextActivityOptions = nextActivityOptions.map((item, i) => {
            return (
                <div className="radiobox-container" key={i}>
                    <input type="radio" name="radio1"
                        value={item.checked}
                        checked={item.checked === nextActivity}
                        onChange={this.handleChanged} />
                    <span className="checkmark">{item.name}</span>
                </div>
            )
        });

        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        <form>
                            <div className="harvest-details">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <div className="form-group d-flex align-items-center">
                                            <label className="w-50 mb-0 font-weight-medium">{SAMPLE_TO_SALE_SCREEN.HARVESTING_DATE}</label>
                                            <div className="input-date w-50 max-w-360">
                                                <input type="date" className="form-control mb-0" name="harvestingDate" value={harvestingDate} onChange={this.changeHandler} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-5">
                                        <div className="form-group d-flex align-items-center">
                                            <label className="w-50 mb-0 font-weight-medium">Threshing Date</label>
                                            <div className="input-date w-50 max-w-360">
                                                <input type="date" className="form-control mb-0" name="threshingDate" value={threshingDate} onChange={this.changeHandler} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-5">
                                        <div className="form-group d-flex align-items-center">
                                            <label className="w-50 mb-0 font-weight-medium">Yield Kgs/5*5 sqm</label>
                                            <div className="w-50 max-w-360">
                                                <input type="number"
                                                    className="form-control mb-0 w-md-100"
                                                    placeholder="eg. 10"
                                                    name="yieldValue"
                                                    value={yieldValue}
                                                    onChange={this.changeHandler} />

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-5">
                                        <div className="form-group d-flex align-items-center">
                                            <label className="w-50 mb-0 font-weight-medium">{SAMPLE_TO_SALE_SCREEN.MOISTURE} %</label>
                                            <div className="w-50 max-w-360">
                                                <input type="number"
                                                    className="form-control mb-0 w-md-100"
                                                    placeholder="eg. 10"
                                                    name="moisture"
                                                    value={moisture}
                                                    onChange={this.changeHandler} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-5">
                                        <div className="form-group d-flex align-items-center">
                                            <label className="w-50 mb-0 font-weight-medium">Population / 5X5 sqm(After Harvesting)</label>
                                            <div className="w-50 max-w-360">
                                                <input type="number"
                                                    className="form-control mb-0 w-md-100"
                                                    placeholder="eg. 10"
                                                    name="population"
                                                    value={population}
                                                    onChange={this.changeHandler} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-5">
                                        <div className="form-group d-flex align-items-center">
                                            <label className="w-50 mb-0 font-weight-medium">Population per ha</label>
                                            <div className="w-50 w-md-100">
                                                <input type="text"
                                                    className="form-control mb-0 max-w-360"
                                                    value={this.calculatePopulationPerHa(population)}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-5">
                                        <div className="form-group d-flex align-items-center">
                                            <label className="w-50 mb-0 font-weight-medium">Yield kg/ha</label>
                                            <div className="w-50 w-md-100">
                                                <input type="text"
                                                    className="form-control mb-0 max-w-360"
                                                    value={this.calculateYield(moisture, yieldValue)}
                                                    readOnly />
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-lg-12"> <h6 className="mt-3">{SAMPLE_TO_SALE_SCREEN.CHECK_HARVEST_DETAILS}</h6></div>


                                    {checkVariety.length > 1 ?
                                        <div className="col-lg-5">
                                            <div className="form-group d-flex align-items-center">
                                                <label className="w-50 mb-0 font-weight-medium">{SAMPLE_TO_SALE_SCREEN.HYBRID}</label>
                                                <Select className="form-group w-50 w-md-100"
                                                    value={selectedCheckVariety}
                                                    onChange={this.handleVarietyHybrid}
                                                    options={checkVariety}
                                                    placeholder="Select the stage"
                                                    isClearable={false} />
                                            </div>

                                        </div> :
                                        <div className="col-lg-5">
                                            <div className="form-group d-flex align-items-center">
                                                <label className="w-50 mb-0 font-weight-medium">{SAMPLE_TO_SALE_SCREEN.HYBRID}</label>
                                                <div className="w-50 w-md-100">
                                                    <input type="text" className="form-control mb-0 max-w-360" value={selectedCheckVariety?.label} disabled />
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    <div className="col-lg-5">
                                        <div className="form-group d-flex align-items-center">
                                            <label className="w-50 mb-0 font-weight-medium">{SAMPLE_TO_SALE_SCREEN.HARVESTING_DATE}</label>
                                            <div className="input-date w-50 w-md-100">
                                                <input type="date"
                                                    className="form-control mb-0 max-w-360"
                                                    name="varietyHarvestingDate"
                                                    value={varietyHarvestingDate}
                                                    onChange={this.changeHandler} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-5">
                                        <div className="form-group d-flex align-items-center">
                                            <label className="w-50 mb-0 font-weight-medium">Threshing Date</label>
                                            <div className="input-date w-50 max-w-360">
                                                <input type="date"
                                                    className="form-control mb-0"
                                                    name="varietyThreshingDate"
                                                    value={varietyThreshingDate}
                                                    onChange={this.changeHandler} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-5">
                                        <div className="form-group d-flex align-items-center">
                                            <label className="w-50 mb-0 font-weight-medium">{SAMPLE_TO_SALE_SCREEN.YIELD} Kgs/5*5 sqm</label>
                                            <div className="w-50 max-w-360">
                                                <input type="number"
                                                    className="form-control mb-0 w-md-100"
                                                    placeholder="eg. 250"
                                                    name="varietyYield"
                                                    value={varietyYield}
                                                    onChange={this.changeHandler} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-5">
                                        <div className="form-group d-flex align-items-center">
                                            <label className="w-50 mb-0 font-weight-medium">{SAMPLE_TO_SALE_SCREEN.MOISTURE} %</label>
                                            <div className="w-50 max-w-360">
                                                <input type="text"
                                                    className="form-control mb-0 w-md-100"
                                                    placeholder="eg. 500"
                                                    name="varietyMoisture"
                                                    value={varietyMoisture}
                                                    onChange={this.changeHandler} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-5">
                                        <div className="form-group d-flex align-items-center">
                                            <label className="w-50 mb-0 font-weight-medium">Population / 5X5 sqm(After Harvesting)</label>
                                            <div className="w-50 max-w-360">
                                                <input type="text"
                                                    className="form-control mb-0 w-md-100"
                                                    placeholder="eg. 500"
                                                    name="varietyPopulation"
                                                    value={varietyPopulation}
                                                    onChange={this.changeHandler} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-5">
                                        <div className="form-group d-flex align-items-center">
                                            <label className="w-50 mb-0 font-weight-medium">Population per ha</label>
                                            <div className="w-50 w-md-100">
                                                <input type="text"
                                                    className="form-control mb-0 max-w-360"
                                                    value={this.calculatePopulationPerHa(varietyPopulation)}
                                                    readOnly />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-5">
                                        <div className="form-group d-flex align-items-center">
                                            <label className="w-50 mb-0 font-weight-medium">Yield kg/ha</label>
                                            <div className="w-50 w-md-100">
                                                <input type="text"
                                                    className="form-control mb-0 max-w-360"
                                                    value={this.calculateYield(varietyMoisture, varietyYield)}
                                                    readOnly />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="form-group">
                                            <label className="font-weight-medium mt-2">{SAMPLE_TO_SALE_SCREEN.REMARKS} <span className="font-weight-normal">(if any)</span></label>
                                            <textarea className="form-control" rows="4" name="remarks" value={remarks} onChange={this.changeHandler}></textarea>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <AddNewImages
                                            handleAddImages={this.handleAddImages}
                                            images={images}
                                            handleDeleteImages={this.handleDeleteImages} />
                                    </div>


                                    <div className="col-lg-12">
                                        <GpsCoordinates getCoordinates={this.getCoordinates} />
                                    </div>

                                    {/* Check For Next Activity */}
                                    {
                                        nextActivity ?
                                            <div className="col-lg-6">
                                                <div className="form-group mb-0">
                                                    <label className="font-weight-medium mt-2">{SAMPLE_TO_SALE_SCREEN.NEXT_PICKING_ACTIVITY_DONE}</label>
                                                    <div className="d-flex flex-wrap radiobox-container-row">
                                                        {NextActivityOptions}
                                                    </div>
                                                </div>
                                            </div> : null
                                    }


                                    {/* Check For Next Activity */}
                                    {
                                        nextActivity ?
                                            <div className="col-lg-6">
                                                <div className="form-group input-date">
                                                    <label>Pick Next Picking Date</label>
                                                    <input type="date" className="form-control mb-0  mt-md-3" onFocus={this.onFocus} onBlur={this.onBlur} placeholder="Pick Next Picking Date"
                                                        name="nextPickDate" value={nextPickDate} onChange={this.changeHandler} min={Utilities.getCurrentDate()} />
                                                </div>
                                            </div> : null
                                    }

                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 d-flex button-grp-bottom">
                        <button className="btn btn-secondary w-50 mr-2 krishak-cancel-btn" onClick={this.backButton}>
                            {COMMON.BACK}
                        </button>
                        <button className="btn btn-primary w-50" onClick={this.handleSaveClick} disabled={this.isFormValid()}>
                            {COMMON.SAVE}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(AddRiceHarvest)